export default getText => key =>
  ({
    title: getText('Your Calendar', 'Home_Tabs_Appointments_Header'),
  }[key])
